import { BadgeModel, RatePlanBadgeModel } from 'src/common/models';

export const adaptRatePlanBadgeModel = (ratePlan): RatePlanBadgeModel => ({
  badge: adaptBadgeModel(ratePlan.badge),
  limitedAvailability: getLimitedAvailability(ratePlan),
});

const adaptBadgeModel = (badge): BadgeModel => ({
  icon: badge?.icon_temp?.id,
  iconTitle: badge?.icon_temp?.description,
  text: badge?.text,
  theme: badge?.theme_temp,
  mark: badge?.mark?.id,
});

const getLimitedAvailability = ratePlan => ratePlan.priceDetails && ratePlan.priceDetails[0].availability?.scarcityMessage;
